import { IConversionFunnelView } from "../interface/trade/IConversionFunnelView";
import { IDetailedLateTicket } from "../interface/trade/IDetailedLateTicket";
import { ILateTicket } from "../interface/trade/ILateTicket";
import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import IQueryStringConversionFunnel from "../queryStrings/IQueryStringConversionFunnel";

enum DiligenceSLAServiceEnum {
  getAverageLateTickets = "/get-average-late-tickets",
  getDetailedLateTickets = "/get-detailed-late-tickets",
  getConversionFunnelDetails = "/get-conversion-funnel-details",
}

export class DiligenceSLAService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/diligence/sla");
  };

  public getAverageLateTickets = async (): Promise<ILateTicket[]> => await this.GET(DiligenceSLAServiceEnum.getAverageLateTickets);
  public getDetailedLateTickets = async (): Promise<IDetailedLateTicket[]> => await this.GET(DiligenceSLAServiceEnum.getDetailedLateTickets);
  public getConversionFunnelDetails = async (data: IQueryStringConversionFunnel): Promise<IConversionFunnelView[]> =>
    await this.POST(DiligenceSLAServiceEnum.getConversionFunnelDetails, data);
}
